import { SvgCircleLoaderController } from './svg-circle-loader.controller'

const component = {
  templateUrl: '/core/components/svg-circle-loader/svg-circle-loader.html?$$REVISION$$',
  bindings: {
    size: '<',
    mayCancel: '<',
    percentage: '<',
    transparent: '<',
    inverted: '<',
    lesserCheck: '<',
    abort: '&'
  },
  controllerAs: '$ctrl',
  controller: SvgCircleLoaderController
}

export const circleLoader = component
